import React from 'react';
const IconBase = ({
  children,
  className,
  ...props
}: any) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className={className} {...props} data-id="element-168" data-mp="2364pfetmqigc">
    {children}
  </svg>;
// Ecosystem Icons
export const IconMoney = (props: any) => <IconBase {...props} data-id="element-169" data-mp="2sb852isj1qwd">
    <rect x="2" y="6" width="20" height="12" rx="2" data-id="element-170" data-mp="2saq273bd0efh" />
    <circle cx="12" cy="12" r="2" data-id="element-171" data-mp="2s954j4tr0fde" />
    <path d="M6 12h.01M18 12h.01" data-id="element-172" data-mp="2x1y8vrlb1loy" />
  </IconBase>;
export const IconCredit = (props: any) => <IconBase {...props} data-id="element-173" data-mp="2jatfv8cfzrnl">
    <rect x="2" y="5" width="20" height="14" rx="2" data-id="element-174" data-mp="2jbl0xp8ey6zm" />
    <path d="M2 10h20" data-id="element-175" data-mp="2nbv8h6but5gl" />
    <path d="M6 15h4" data-id="element-176" data-mp="2nb3mmn826m3i" />
  </IconBase>;
export const IconAI = (props: any) => <IconBase {...props} data-id="element-177" data-mp="29cdod49i6gdk">
    <path d="M12 3a9 9 0 0 0 0 18 9 9 0 0 0 0-18Z" data-id="element-178" data-mp="29bu61mfxxpz0" />
    <path d="M12 8v8" data-id="element-179" data-mp="29egc1hn6nxf4" />
    <path d="M8 12h8" data-id="element-180" data-mp="2eaxbh7zu1y7i" />
    <circle cx="12" cy="12" r="2" data-id="element-181" data-mp="2ea5f3uyevwg6" />
    <path d="M10 10l-2-2M14 10l2-2M10 14l-2 2M14 14l2 2" data-id="element-182" data-mp="2eafa5wybctsq" />
  </IconBase>;
export const IconSoftware = (props: any) => <IconBase {...props} data-id="element-183" data-mp="20ks7wn44mneu">
    <rect x="4" y="4" width="16" height="16" rx="2" data-id="element-184" data-mp="1vke2lctwtrki" />
    <path d="M4 9h16" data-id="element-185" data-mp="1vjkzclu5tk74" />
    <path d="M9 4v16" data-id="element-186" data-mp="29jnfo3mtk5k9" />
  </IconBase>;
export const IconRewards = (props: any) => <IconBase {...props} data-id="element-187" data-mp="29hjcjnwqval1">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-188" data-mp="24kspuhqfpgqn" />
  </IconBase>;
export const IconBusiness = (props: any) => <IconBase {...props} data-id="element-189" data-mp="1gsvqhq468h6f">
    <rect x="2" y="7" width="20" height="14" rx="2" data-id="element-190" data-mp="1ctmvyj1b4f9t" />
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" data-id="element-191" data-mp="1cuy1anaehv31" />
    <path d="M12 12v2" data-id="element-192" data-mp="1qlb7ak3qezpq" />
  </IconBase>;
// Trust Section Icons
export const IconEditorial = (props: any) => <IconBase {...props} data-id="element-193" data-mp="1ltt4dqi5ep24">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" data-id="element-194" data-mp="1lt9p6hjvuers" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" data-id="element-195" data-mp="y4gvysunal0v" />
    <path d="M10 6h6M10 10h6M10 14h2" data-id="element-196" data-mp="y2e21xqdg7qv" />
  </IconBase>;
export const IconResearch = (props: any) => <IconBase {...props} data-id="element-197" data-mp="t3b22rp90rpr">
    <circle cx="11" cy="11" r="8" data-id="element-198" data-mp="2t7wsup67gyk6" />
    <path d="M21 21l-4.35-4.35" data-id="element-199" data-mp="2t6u4anwcv87f" />
    <path d="M11 8v6" data-id="element-200" data-mp="2t5j1aqaqi4hd" />
    <path d="M8 11h6" data-id="element-201" data-mp="2y6ghixc6oog8" />
  </IconBase>;
export const IconHumanAI = (props: any) => <IconBase {...props} data-id="element-202" data-mp="2y4dixowytmzw">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-203" data-mp="32www4krqqg46" />
    <circle cx="9" cy="7" r="4" data-id="element-204" data-mp="32zjezgk30i1p" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" data-id="element-205" data-mp="37w9spx8ez1jy" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-206" data-mp="37w01y7fjoqd7" />
  </IconBase>;
export const IconUpdates = (props: any) => <IconBase {...props} data-id="element-207" data-mp="2aac3zi3fxzzk">
    <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" data-id="element-208" data-mp="2aavkqvhcuic0" />
    <path d="M21 3v5h-5" data-id="element-209" data-mp="2f8ngk0l4eolh" />
    <path d="M12 7v5l3 3" data-id="element-210" data-mp="2f9yiduv09m9y" />
  </IconBase>;